import React from "react";

const Footer=()=>{

    return(

        <>
        <footer><div class="container-fluid">
        <div class="row">
          <div class="d-lg-flex justify-content-between align-items-center">

            <div class="text-body-secondary"> Copyright 2025.All Rights Reserved. </div>
            <ul class="list-inline">
              {/* <p class="list-inline-item">No. of Visitors - {visits}</p> */}
              {/* <a href="https://info.flagcounter.com/YNCE"><img src="https://s11.flagcounter.com/count2/YNCE/bg_FFFFFF/txt_000000/border_CCCCCC/columns_2/maxflags_1/viewers_0/labels_0/pageviews_0/flags_0/percent_0/" alt="Flag Counter" border="0"/></a> */}
              {/* <a href="https://www.coolseotools.com/flag-counter/details/b0N/"><img src="https://www.coolseotools.com/flag-counter/load/b0N/" alt="Flag Counter"/></a> */}
              <li class="list-inline-item"> <a class="px-2 text-facebook rounded-pill" href="#"><i class="fab fa-fw fa-facebook-f"></i></a> </li>
              <li class="list-inline-item"> <a class="px-2 text-instagram rounded-pill" href="#"><i class="fab fa-fw fa-instagram"></i></a> </li>
              <li class="list-inline-item"> <a class="px-2 text-twitter rounded-pill" href="#"><i class="fab fa-fw fa-twitter"></i></a> </li>
              <li class="list-inline-item"> <a class="px-2 text-linkedin rounded-pill" href="#"><i class="fab fa-fw fa-linkedin-in"></i></a> </li>
            </ul>
          </div>
        </div></div></footer>
        </>
    )

}
 export default Footer;